import '../../styles/components/trails-gpx-download.scss'

;(() => {
	const mL = string => {
		const data = {
			title: {
				it: 'IMPORTANTE!',
				en: 'IMPORTANT!',
				de: 'WICHTIG!',
			},
			closeModal: {
				it: 'Chiudi modale',
				en: 'Close modal',
				de: 'Modal schließen',
			},
			contentHTML: {
				it: `<p>I tracciati Gps degli itinerari presenti in questo sito web (realizzati in formato gpx) sono stati rilevati con apposita strumentazione e/o preparati/rivisti tramite software apposito; si segnala che possono, tuttavia, contenere imprecisioni, errori, lacune, ecc.</p><p>Tutti i percorsi proposti sono stati redatti e tracciati con cura; ciononostante possono presentare sviste, sbagli o indicazioni imprecise (qualora ne notiate non esitate a comunicarcelo, scrivendo a <a href="mailto:info@asiago.it">info@asiago.it</a>).  È perciò consigliabile attrezzarsi di cartine escursionistiche apposite o Gps.</p><p>Ricordiamo che<strong> fare camminate o percorrere itinerari ed escursioni di qualsiasi tipo in montagna, a piedi o con altri mezzi, è sempre un’attività potenzialmente pericolosa</strong>. Vi raccomandiamo, quindi, la massima prudenza e <strong>decliniamo ogni responsabilità</strong> per qualsiasi incidente, danno, disguido o disavventura possa derivare agli utenti percorrendo gli itinerari proposti nel nostro sito.</p><p>Qualora vogliate inviarci proposte di integrazione, informazioni o segnalazioni in merito agli itinerari da noi presentati nel nostro sito, potete scriverci a <a href="mailto:info@webcloud.it">info@webcloud.it</a>. <strong>Suggerimenti, foto e video</strong> sono sempre ben accetti.</p><hr><p><strong>COPYRIGHT</strong></p><p><strong>Tutti i contenuti di questo sito appartengono a <a href="http://Asiago.it/Webcloud">Webcloud</a> di Andrea Vescovi</strong>, ditta proprietaria del portale <a href="http://Asiago.it">Asiago.it</a>. Per quanto riguarda gli <strong>itinerari</strong>, né è <strong>concesso l’utilizzo a titolo gratuito esclusivamente per uso personale</strong>, come ausilio durante le escursioni.</p><p>Ne sono invece <strong>vietati la riproduzione e l’uso (a scopo di lucro o meno) su altri siti web, servizi o pubblicazioni sia online che cartacee, e per ogni altro utilizzo diverso da quello personale</strong> come ausilio nelle escursioni. Per tali scopi è necessario ottenere una liberatoria scritta da parte <a href="http://Asiago.it/Webcloud">Webcloud</a> di Andrea Vescovi.</p>`,
				en: `<p>The Gps tracks of the routes on this website (made in gpx format) have been detected with special instrumentation and/or prepared/revised through special software; however, they may contain inaccuracies, errors, gaps, etc.</p><p>All the proposed routes have been carefully drawn up and plotted; however, they may present oversights, mistakes or inaccurate indications (if you notice it do not hesitate to tell us, writing to <a href="mailto:info@asiago.it">info@asiago.it).</a> &nbsp;It is therefore advisable to equip yourself with dedicated hiking maps or Gps.</p><p>Remember that<strong> walking or hiking any kind in the mountains, on foot or by other means is always a potentially dangerous activity.</strong> We recommend, therefore, the utmost prudence and <strong>we decline any responsibility</strong> for any accident, damage, misadventure or misadventure may result from users following the routes proposed on our site.</p><p>If you would like to send us proposals for integration, information or reports about the itineraries presented by us on our website, you can write to us <a href="mailto:info@webcloud.it">at info@webcloud.it.</a> <strong>Suggestions, photos and videos</strong> are always welcome.</p><hr/><p><strong>Copyright</strong></p><p><strong>All the contents of this site belong to <a href="http://Asiago.it/Webcloud">Webcloud</a> by Andrea Vescovi,</strong>company that owns the <a href="http://Asiago.it">portal Asiago.it.</a> As for the <strong>itineraries,</strong>neither is <strong>allowed to be used free of charge exclusively for personal use,</strong>as an aid during excursions.</p><p>On the other hand, it is <strong>forbidden to reproduce and use (for profit or not) on other websites, services or publications both online and in print, and for any other use other than the personal one</strong> as an aid in excursions. For these purposes it is necessary to obtain a written release from <a href="http://Asiago.it/Webcloud">Webcloud</a> of Andrea Bishops.</p>`,
				de: `<p>Die Gps-Spuren der Routen auf dieser Website (im gpx-Format) wurden mit spezieller Instrumentierung erkannt und/oder durch spezielle Software vorbereitet/&uuml;berarbeitet; Sie k&ouml;nnen jedoch Ungenauigkeiten, Fehler, L&uuml;cken usw. enthalten.</p><p>Alle vorgeschlagenen Routen wurden sorgf&auml;ltig ausgearbeitet und aufgeplottet; sie k&ouml;nnen jedoch Versehen, Fehler oder ungenaue Angaben enthalten (wenn Sie bemerken, dass es nicht z&ouml;gern, uns zu sagen, schreiben <a href="mailto:info@asiago.it">Sie an info@asiago.it).</a> &nbsp;Es ist daher ratsam, sich mit speziellen Wanderkarten oder Gps auszustatten.</p><p>Denken Sie daran, dass<strong> Wandern oder Wandern jede Art von Art in den Bergen, zu Fu&szlig; oder mit anderen Mitteln ist immer eine potenziell gef&auml;hrliche Aktivit&auml;t.</strong> Wir empfehlen daher &auml;u&szlig;erste Vorsicht und <strong>lehnen jegliche Verantwortung</strong> f&uuml;r Unf&auml;lle, Sch&auml;den, Missgeschicke oder Missgeschicke ab, die von Benutzern sein k&ouml;nnen, die die auf unserer Website vorgeschlagenen Routen befolgen.</p><p>Wenn Sie uns Integrationsvorschl&auml;ge, Informationen oder Berichte &uuml;ber die von uns auf unserer Website pr&auml;sentierten Reiserouten zusenden m&ouml;chten, k&ouml;nnen Sie uns <a href="mailto:info@webcloud.it">bitte info@webcloud.it.</a> <strong>Anregungen, Fotos und Videos</strong> sind immer willkommen.</p><hr/><p><strong>Copyright</strong></p><p><strong>Alle Inhalte dieser Website geh&ouml;ren <a href="http://Asiago.it/Webcloud">Webcloud</a> von Andrea Vescovi,</strong>einer Firma, der das <a href="http://Asiago.it">Portal geh&ouml;rt Asiago.it.</a> Was die <strong>Routen betrifft,</strong>so ist keine der beiden kostenlosen <strong>Nutzungen ausschlie&szlig;lich f&uuml;r den pers&ouml;nlichen Gebrauch,</strong>als Hilfe bei Ausfl&uuml;gen gestattet.</p><p>Andererseits ist es verboten, andere <strong>Websites, Dienstleistungen oder Ver&ouml;ffentlichungen online und in gedruckter Form zu reproduzieren und zu verwenden (gewinnbringend oder nicht) und f&uuml;r jede andere Verwendung als die pers&ouml;nliche</strong> als Hilfe bei Ausfl&uuml;gen. Zu diesem Zweck ist es notwendig, eine schriftliche Ver&ouml;ffentlichung von <a href="http://Asiago.it/Webcloud">Webcloud</a> von Andrea Bishops zu erhalten.</p>`,
			},
			btnPrimary: {
				it: 'Accetta e Scarica',
				en: 'Accept and Download',
				de: 'Akzeptieren und herunterladen',
			},
			btnSecondary: {
				it: 'Annulla',
				en: 'Cancel',
				de: 'Stornieren',
			},
			btnSecondaryAriaLabel: {
				it: 'Chiudi la finestra di dialogo',
				en: 'Close the dialog',
				de: 'Schließen Sie den Dialog',
			},
			btnReadmore: {
				it: 'Leggi tutto',
				en: 'Read everything',
				de: 'Lesen Sie alles',
			},
			downloadText: {
				it: 'Scarica la traccia GPS',
				en: 'Download the GPS track',
				de: 'Laden Sie den GPS-Track herunter',
			},
			panelTitle: {
				it: 'Tracciato GPX',
				en: 'GPX track',
				de: 'GPX-Track',
			},
			trackAvailable: {
				it: 'File GPX disponibile',
				en: 'GPX file available',
				de: 'GPX-Datei verfügbar',
			},
			trackMissing: {
				it: 'Nessun file GPX caricato',
				en: 'No GPX file uploaded',
				de: 'Keine GPX-Datei hochgeladen',
			},
			selectFile: {
				it: 'Seleziona un file .gpx',
				en: 'Select a .gpx file',
				de: 'Eine .gpx-Datei auswählen',
			},
			importTrack: {
				it: 'Importa tracciato',
				en: 'Import track',
				de: 'Track importieren',
			},
			replaceTrack: {
				it: 'Sostituisci tracciato',
				en: 'Replace track',
				de: 'Track ersetzen',
      },
      deleteTrack: {
        it: 'Rimuovi tracciato',
        en: 'Remove track',
        de: 'Track entfernen',
      },
      deleting: {
        it: 'Rimozione in corso…',
        en: 'Removing…',
        de: 'Entfernung läuft…',
      },
      confirmDelete: {
        it: 'Il GPX originale, i JSON della mappa e del grafico e i relativi blocchi nell’articolo verranno rimossi. Confermi?',
        en: 'The original GPX, map and chart JSON files and the related article blocks will be removed. Continue?',
        de: 'Die ursprüngliche GPX-Datei, die JSON-Dateien und die zugehörigen Artikelblöcke werden entfernt. Fortfahren?',
      },
      deleteCompleted: {
        it: 'Il tracciato è stato rimosso correttamente. La pagina verrà ricaricata.',
        en: 'The track was removed successfully. The page will reload.',
        de: 'Der Track wurde erfolgreich entfernt. Die Seite wird neu geladen.',
      },
      instructionsText: {
        it: 'Istruzioni per creare o modificare il GPX',
        en: 'Instructions for creating or editing the GPX',
        de: 'Anleitung zum Erstellen oder Bearbeiten der GPX-Datei',
      },
			uploading: {
				it: 'Importazione in corso…',
				en: 'Importing…',
				de: 'Import läuft…',
			},
			confirmImport: {
				it: 'Confermi l’importazione del file GPX selezionato?',
				en: 'Do you want to import the selected GPX file?',
				de: 'Möchten Sie die ausgewählte GPX-Datei importieren?',
			},
			confirmReplace: {
				it: 'Il tracciato attuale e i relativi JSON verranno sostituiti. Confermi?',
				en: 'The current track and its JSON files will be replaced. Continue?',
				de: 'Der aktuelle Track und seine JSON-Dateien werden ersetzt. Fortfahren?',
			},
			importCompleted: {
				it: 'Tracciato importato correttamente. La pagina verrà ricaricata.',
				en: 'Track imported successfully. The page will reload.',
				de: 'Track erfolgreich importiert. Die Seite wird neu geladen.',
			},
			genericError: {
				it: 'Non è stato possibile completare l’operazione.',
				en: 'The operation could not be completed.',
				de: 'Der Vorgang konnte nicht abgeschlossen werden.',
			},
			pointsLabel: {
				it: 'Punti',
				en: 'Points',
				de: 'Punkte',
			},
			markersLabel: {
				it: 'Marker',
				en: 'Markers',
				de: 'Marker',
			},
			distanceLabel: {
				it: 'Distanza',
				en: 'Distance',
				de: 'Distanz',
			},
			elevationLabel: {
				it: 'Quota',
				en: 'Elevation',
				de: 'Höhe',
			},
			updatedLabel: {
				it: 'Aggiornato',
				en: 'Updated',
				de: 'Aktualisiert',
			},
		}

		return data?.[string] ? data[string][WC.lang.substr(0, 2)] : '???'
	}

	const processContentReadmore = html => {
		if (!html.includes('<!--READMORE-->')) {
			return html
		}
		const texts = html.split('<!--READMORE-->')
		const intro = texts[0]
		const more = texts[1]

		let newHtml = `
			<div class="modal-content-intro">${intro}</div>
			<a class="modal-content-readmore" href="javascript:void(0)">${mL(
				'btnReadmore'
			)}</a>
			<div class="modal-content-more" style="display: none">${more}</div>
		`

		return newHtml
	}

	const processModal = modalId => {
		const modal = document.querySelector(`#${modalId}`)

		modal.querySelector(`#${modalId}__title`).textContent = mL('title')
		modal
			.querySelector(`.modal__close`)
			.setAttribute('aria-label', mL('closeModal'))
		modal.querySelector(
			`#${modalId}__content`
		).innerHTML = processContentReadmore(mL('contentHTML'))
		modal.querySelector('.modal__btn-primary').textContent = mL(
			'btnPrimary'
		)
		modal.querySelector('.modal__btn-secondary').textContent = mL(
			'btnSecondary'
		)
		modal
			.querySelector('.modal__btn-secondary')
			.setAttribute('aria-label', mL('btnSecondaryAriaLabel'))

		// Events
		const readmore = modal.querySelector(
			`#${modalId}__content .modal-content-readmore`
		)

		if (readmore) {
			readmore.addEventListener('click', e => {
				e.preventDefault()
				e.target.parentNode.querySelector(
					'.modal-content-more'
				).style.display = 'block'
				e.target.remove()
			})
		}
	}


	const TRAIL_MENU_IDS = [36, 80, 120]
  const MODAL_ID = 'modal-trailsgpx'
  const GPX_INSTRUCTIONS_URL =
    'https://docs.webcloud.it/doc/istruzioni-per-creare-tracciati-gpx-da-pc-con-punti-di-interesse-1K0XNAQpGv'

	const ensureDisclaimerModal = () => {
		let modal = document.querySelector(`#${MODAL_ID}`)

		if (!modal) {
			modal = document.createElement('div')
			modal.className = 'modal micromodal-slide'
			modal.id = MODAL_ID
			modal.setAttribute('aria-hidden', 'true')
			modal.innerHTML = `
				<div class="modal__overlay" tabindex="-1" data-micromodal-close>
					<div class="modal__container" role="dialog" aria-modal="true" aria-labelledby="${MODAL_ID}__title">
						<header class="modal__header">
							<h2 class="modal__title" id="${MODAL_ID}__title"></h2>
							<button class="modal__close" aria-label="" data-micromodal-close></button>
						</header>
						<main class="modal__content" id="${MODAL_ID}__content"></main>
						<footer class="modal__footer">
							<button class="modal__btn modal__btn-primary"></button>
							<button class="modal__btn modal__btn-secondary" data-micromodal-close></button>
						</footer>
					</div>
				</div>
			`
			document.body.appendChild(modal)
		}

		if (modal.dataset.trailsGpxInitialised !== 'true') {
			processModal(MODAL_ID)
			modal.dataset.trailsGpxInitialised = 'true'
		}

		return modal
	}

	const closeDisclaimerModal = modal => {
		if (window.MicroModal) {
			MicroModal.close(MODAL_ID)
			return
		}

		modal.classList.remove('is-open')
		modal.setAttribute('aria-hidden', 'true')
	}

	const showDisclaimerModal = onAccept => {
		const modal = ensureDisclaimerModal()
		const primary = modal.querySelector('.modal__btn-primary')
		const closeTargets = modal.querySelectorAll('[data-micromodal-close]')

		primary.onclick = event => {
			event.preventDefault()
			closeDisclaimerModal(modal)
			onAccept()
		}

		if (!window.MicroModal) {
			for (const target of closeTargets) {
				target.onclick = event => {
					event.preventDefault()
					closeDisclaimerModal(modal)
				}
			}

			modal.classList.add('is-open')
			modal.setAttribute('aria-hidden', 'false')
			return
		}

		MicroModal.show(MODAL_ID)
	}

	const formatNumber = value =>
		new Intl.NumberFormat(WC.lang || 'it-IT', {
			maximumFractionDigits: 1,
		}).format(value)

	const formatDate = value => {
		if (!value) {
			return ''
		}

		const date = new Date(value)

		if (Number.isNaN(date.getTime())) {
			return ''
		}

		return new Intl.DateTimeFormat(WC.lang || 'it-IT', {
			dateStyle: 'short',
			timeStyle: 'short',
		}).format(date)
	}

	const buildMetadata = state => {
		if (!state.hasFile) {
			return ''
		}

		const values = []

		if (Number.isFinite(state.trackPointCount)) {
			values.push(`${mL('pointsLabel')}: ${formatNumber(state.trackPointCount)}`)
		}

		if (Number.isFinite(state.markerCount)) {
			values.push(`${mL('markersLabel')}: ${formatNumber(state.markerCount)}`)
		}

		if (Number.isFinite(state.distanceMeters)) {
			values.push(
				`${mL('distanceLabel')}: ${formatNumber(state.distanceMeters / 1000)} km`
			)
		}

		if (
			Number.isFinite(state.minElevation) &&
			Number.isFinite(state.maxElevation)
		) {
			values.push(
				`${mL('elevationLabel')}: ${formatNumber(state.minElevation)}–${formatNumber(
					state.maxElevation
				)} m`
			)
		}

		const updated = formatDate(state.importedAtUtc)
		if (updated) {
			values.push(`${mL('updatedLabel')}: ${updated}`)
		}

		return values
			.map(value => `<span class="trails-gpx-manager__meta-item">${value}</span>`)
			.join('')
	}

	const getDownloadFileName = response => {
		const fallback = `itinerario-${WC.idArticolo}.gpx`
		const disposition = response.headers.get('content-disposition')

		if (!disposition) {
			return fallback
		}

		const utf8Match = disposition.match(/filename\*=UTF-8''([^;]+)/i)

		if (utf8Match?.[1]) {
			try {
				return decodeURIComponent(utf8Match[1])
			} catch {
				return utf8Match[1]
			}
		}

		const filenameMatch = disposition.match(/filename="?([^";]+)"?/i)

		return filenameMatch?.[1] || fallback
	}

	const getDownloadErrorMessage = async response => {
		const contentType = response.headers.get('content-type') || ''

		if (contentType.includes('application/json')) {
			try {
				const payload = await response.json()
				return payload?.message || mL('genericError')
			} catch {
				return mL('genericError')
			}
		}

		return mL('genericError')
	}

	const downloadGpx = () => {
		showDisclaimerModal(async () => {
			const url = new URL(window.location.href)
			url.searchParams.delete('wcTrailGpxAction')

			const formData = new FormData()
			formData.append('wcTrailGpxAction', 'download')

			try {
				const response = await fetch(url.toString(), {
					method: 'POST',
					mode: 'same-origin',
					cache: 'no-store',
					credentials: 'same-origin',
					body: formData,
				})

				if (!response.ok) {
					throw new Error(await getDownloadErrorMessage(response))
				}

				const contentType = response.headers.get('content-type') || ''

				if (contentType.includes('text/html')) {
					throw new Error(mL('genericError'))
				}

				const blob = await response.blob()

				if (!blob.size) {
					throw new Error(mL('genericError'))
				}

				const blobUrl = URL.createObjectURL(blob)
				const node = document.createElement('a')

				node.href = blobUrl
				node.download = getDownloadFileName(response)
				node.style.display = 'none'

				document.body.appendChild(node)
				node.click()
				node.remove()

				window.setTimeout(() => {
					URL.revokeObjectURL(blobUrl)
				}, 1000)
			} catch (error) {
				console.error('[Trail GPX] Download failed', error)
				window.alert(error?.message || mL('genericError'))
			}
		})
  }

  const deleteGpx = async ({ button, status }) => {
    if (!window.confirm(mL('confirmDelete'))) {
      return
    }

    const url = new URL(window.location.href)
    url.searchParams.delete('wcTrailGpxAction')

    const formData = new FormData()
    formData.append('wcTrailGpxAction', 'delete')

    const previousLabel = button.textContent

    button.disabled = true
    button.textContent = mL('deleting')
    status.textContent = mL('deleting')

    try {
      const response = await fetch(url.toString(), {
        method: 'POST',
        mode: 'same-origin',
        cache: 'no-store',
        credentials: 'same-origin',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: formData,
      })

      const responseText = await response.text()
      let payload = null

      try {
        payload = JSON.parse(responseText)
      } catch (error) {
        console.error(
          '[trails-gpx] Risposta di rimozione non valida',
          error,
          responseText
        )
      }

      if (!response.ok || !payload?.ok) {
        throw new Error(
          payload?.message || mL('genericError')
        )
      }

      window.alert(
        payload?.message || mL('deleteCompleted')
      )

      window.location.reload()
    } catch (error) {
      console.error(
        '[trails-gpx] Rimozione non completata',
        error
      )

      status.textContent =
        error?.message || mL('genericError')

      button.disabled = false
      button.textContent = previousLabel
    }
  }

	const uploadGpx = async ({file, state, button, status}) => {
		const confirmation = state.hasFile ? mL('confirmReplace') : mL('confirmImport')

		if (!window.confirm(confirmation)) {
			return
		}

		const formData = new FormData()
		formData.append('wcTrailGpxAction', 'upload')
		formData.append('gpx', file, file.name)

		const previousLabel = button.textContent
		button.disabled = true
		status.textContent = mL('uploading')

		try {
			const response = await fetch(window.location.href, {
				method: 'POST',
				body: formData,
				credentials: 'same-origin',
				headers: {
					'X-Requested-With': 'XMLHttpRequest',
				},
			})

			const responseText = await response.text()
			let payload = null

			try {
				payload = JSON.parse(responseText)
			} catch (error) {
				console.error('[trails-gpx] Risposta non valida', error, responseText)
			}

			if (!response.ok || !payload?.ok) {
				throw new Error(payload?.message || mL('genericError'))
			}

			window.alert(payload?.message || mL('importCompleted'))
			window.location.reload()
		} catch (error) {
			console.error('[trails-gpx] Importazione non completata', error)
			status.textContent = error.message || mL('genericError')
			button.disabled = false
			button.textContent = previousLabel
		}
	}

	const createManager = (state, target) => {
		const manager = document.createElement('section')
		manager.className = 'trails-gpx-manager'
		manager.setAttribute('data-trails-gpx-manager', '')

		manager.innerHTML = `
			<div class="trails-gpx-manager__header">
				<strong class="trails-gpx-manager__title">${mL('panelTitle')}</strong>
				<span class="trails-gpx-manager__state ${
					state.hasFile
						? 'trails-gpx-manager__state--available'
						: 'trails-gpx-manager__state--missing'
				}">${state.hasFile ? mL('trackAvailable') : mL('trackMissing')}</span>
			</div>
			${
				state.originalFileName
					? `<div class="trails-gpx-manager__filename">${state.originalFileName}</div>`
					: ''
			}
			<div class="trails-gpx-manager__metadata">${buildMetadata(state)}</div>
			<div class="trails-gpx-manager__controls">
				${
      state.hasFile
        ? `<button
								type="button"
								class="trails-gpx-manager__button trails-gpx-manager__button--download"
								data-trails-gpx-download
							>${mL('downloadText')}</button>`
        : ''
      }

				<label class="trails-gpx-manager__file-label">
					<span>${mL('selectFile')}</span>
					<input
						type="file"
						accept=".gpx,application/gpx+xml,application/xml,text/xml"
						data-trails-gpx-file
					/>
				</label>

				<button
					type="button"
					class="trails-gpx-manager__button trails-gpx-manager__button--primary"
					data-trails-gpx-upload
					disabled
				>
					${state.hasFile ? mL('replaceTrack') : mL('importTrack')}
				</button>

				${state.hasFile
        ? `<button
								type="button"
								class="trails-gpx-manager__button trails-gpx-manager__button--danger"
								data-trails-gpx-delete
							>${mL('deleteTrack')}</button>`
        : ''
      }

				<a
					class="trails-gpx-manager__button trails-gpx-manager__button--instructions"
					href="${GPX_INSTRUCTIONS_URL}"
					target="_blank"
					rel="noopener noreferrer"
				>${mL('instructionsText')}</a>
			</div>
			<div class="trails-gpx-manager__status" role="status" aria-live="polite"></div>
		`

		const fileInput = manager.querySelector('[data-trails-gpx-file]')
		const uploadButton = manager.querySelector('[data-trails-gpx-upload]')
    const downloadButton = manager.querySelector('[data-trails-gpx-download]')
    const deleteButton = manager.querySelector(
      '[data-trails-gpx-delete]'
    )
		const status = manager.querySelector('.trails-gpx-manager__status')
		const fileLabelText = manager.querySelector('.trails-gpx-manager__file-label span')

		fileInput.addEventListener('change', () => {
			const file = fileInput.files?.[0] || null
			uploadButton.disabled = !file
			fileLabelText.textContent = file?.name || mL('selectFile')
			status.textContent = ''
		})

		uploadButton.addEventListener('click', () => {
			const file = fileInput.files?.[0]

			if (!file) {
				return
			}

			uploadGpx({file, state, button: uploadButton, status})
		})

    downloadButton?.addEventListener('click', downloadGpx)
    deleteButton?.addEventListener('click', () => {
      deleteGpx({
        button: deleteButton,
        status,
      })
    })

		if (target.matches('.iframe-container-trailmap, .iframe-container-trailquote')) {
			target.insertAdjacentElement('afterend', manager)
		} else {
			target.appendChild(manager)
		}
	}

	const run = () => {
		const menuId = Number(WC?.idMenu)
		const articleId = Number(WC?.idArticolo)
		const state = WC?.PageVars?.trailGpx

		if (
			WC?.isAuth !== true ||
			!TRAIL_MENU_IDS.includes(menuId) ||
			!Number.isInteger(articleId) ||
			articleId <= 0 ||
			!state ||
			document.querySelector('[data-trails-gpx-manager]')
		) {
			return
		}

		const target =
			document.querySelector('.iframe-container-trailquote') ||
			document.querySelector('.iframe-container-trailmap') ||
			document.querySelector('.article-body-editable') ||
			document.querySelector('.body-page .riquadro #content')

		if (!target) {
			return
		}

		createManager(state, target)
	}

	run()
})()
